import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import {SegmentProps} from '../types';
import segmentsKeys from '../util/segments-keys';

export interface CreateSegmentProps extends Omit<SegmentProps, 'id'> {}

const useCreateSegment = () => {
  const {create} = useInfiniteQueryHelpers();

  const onSuccess = (data: SegmentProps) => create(segmentsKeys.list(), data);

  return useApiMutation<SegmentProps>({
    url: '/segments',
    method: 'POST',
    errorTitle: 'Erro ao cadastrar segmento',
    successTitle: 'Cadastrar segmento',
    successMessage: 'Segmento cadastrado com sucesso',
    redirectUrl: '/settings/segments',
    onSuccess,
  });
};

export default useCreateSegment;
